import { __assign } from "tslib";
export var mergeOptions = function (id, chartOptions, settings) {
    var options = chartOptions.filter(function (group) { return group.id !== id; });
    var mergedSettings = options.reduce(function (acc, item) {
        var groupSettings = {};
        item.settings.forEach(function (_a) {
            var isActive = _a.isActive, defaultValue = _a.defaultValue;
            if (isActive(settings)) {
                groupSettings = defaultValue;
            }
        });
        return __assign(__assign({}, acc), groupSettings);
    }, {});
    return mergedSettings;
};
